import { useEffect, useRef } from 'react';

/** Call `onEscape` when Escape is pressed anywhere, while `active`. */
export function useEscapeKey(onEscape: () => void, active = true) {
  const fn = useRef(onEscape);
  fn.current = onEscape;
  useEffect(() => {
    if (!active) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && fn.current();
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [active]);
}
